<template>
  <router-view />
</template>

<style>
:root {
  --ink: #111111;
  --muted: #626262;
  --line: #e6e6e2;
  --warm: #f4c451;
  --paper: #ffffff;
  --soft: #f7f7f4;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--paper);
  color: var(--ink);
  font-family: "Noto Sans TC", "PingFang TC", "Microsoft JhengHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

button,
a {
  font: inherit;
}

img {
  display: block;
  max-width: 100%;
}

#app {
  min-height: 100vh;
}
</style>
